export default function PrivacyPage() {
  return (
    <div style={{ padding: "2rem", direction: "rtl" }}>
      <h1>מדיניות פרטיות</h1>
      <p>הפרטיות שלכם חשובה לנו.</p>
      <p>
        אתר matay.today משתמש בקבצי עוגיות (Cookies) לצורך תפעול, שיפור חוויית המשתמש, ניתוח תנועה, ושילוב פרסומות.
      </p>
      <p>
        האתר עושה שימוש בשירותי צד שלישי, כולל Google AdSense, אשר עשויים לאסוף מידע אנונימי על הרגלי הגלישה שלכם לצורך התאמת פרסומות.
      </p>
      <p>
        למידע נוסף ניתן לעיין ב
        <a href="https://policies.google.com/privacy?hl=iw" target="_blank" rel="noreferrer" style={{ marginInlineStart: '0.3em' }}>
          מדיניות הפרטיות של Google
        </a>.
      </p>
      <p>בפנייה אלינו בנושא פרטיות, ניתן לכתוב לכתובת: meitalbenshabat2@gmail.com</p>
    </div>
  );
}
